import React, { useState, useEffect, useRef } from 'react';
import { SearchField } from '@p81-common/ui';

import { Text, EmptyState } from 'components/common/Elements/Elements';
import Account from './parts/Account/Account';
import DropDownMenu from './parts/DropDownMenu/DropDownMenu';

import { getRequest } from 'utils/requests';

import LogoText from 'assets/svg/jarvis_mobile.svg';

import classes from './Main.module.scss';

const Main = () => {
  const unmount = useRef(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const handleSearch = e => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    requestForSearch();
    // eslint-disable-next-line
  }, [search]);

  const searchClear = () => {
    setSearch('');
  };

  const requestForSearch = () => {
    setLoader(true);
    if (search.length > 2) {
      const linkForRequest = `/mob/customers/list?search=${search}`;
      getRequest(linkForRequest)
        .then(res => {
          if (!unmount.current) {
            setData(res.body.data);
          }
        })
        .catch(err => {
          if (!unmount.current) {
            console.log(err);
          }
        })
        .finally(() => {
          if (!unmount.current) {
            setLoader(false);
          }
        });
    }
  };

  return (
    <>
      <img
        className={classes.logo}
        src={LogoText}
        alt="Link to the home page"
        width="190"
      />
      <Text size={2} className={classes.text}>
        Radically Simple Tenant Insights
      </Text>
      <div className={classes.wrapSearch}>
        <SearchField
          placeholder={'Search tenant'}
          value={search}
          handleChangeCallback={handleSearch}
          handleClear={searchClear}
          className={classes.search}
        />
        {data.length > 0 && search.length > 2 && !loader && (
          <DropDownMenu>
            <ul>
              {data.map((tenant, index) => (
                <li key={index} className={classes.list}>
                  <Account company={tenant} />
                </li>
              ))}
            </ul>
          </DropDownMenu>
        )}
        {data.length === 0 && search.length > 2 && !loader && <EmptyState />}
      </div>
    </>
  );
};

export default Main;
